export default __webpack_public_path__ + "static/wind04-32afc9cd9f46093c14a8a96491f27212.jpg";